import type { GridColDef } from "@mui/x-data-grid-premium";
import type { Answer, Option } from "../dynamicForm";

export const getLabelFromOptions = (value: Answer["value"] | undefined, options: Option[]) =>
  options.find(o => o.value === value)?.label;

type RequiredColDef = (required: {
  field: string;
  headerName: string;
}) => Pick<GridColDef, "field" | "headerName" | "minWidth" | "width">;
export const requiredColDef: RequiredColDef = ({ field, headerName }) => ({
  width: 240,
  minWidth: 180,
  field,
  headerName,
});
